import { Component, Input } from '@angular/core';
import { DLEntry } from '../../models/description-list-entry.model';

@Component({
    selector: 'app-description-list-v2',
    templateUrl: './description-list-v2.component.html',
    styleUrls: ['./description-list-v2.component.scss'],
    standalone: false
})
export class DescriptionListV2Component {
  @Input() entries: DLEntry[];
}
